import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import './Menu.css'
import {MenuOption} from './MenuOption'
import ComputerIcon from '@material-ui/icons/Computer';
import PersonIcon from '@material-ui/icons/Person';
import LanguageIcon from '@material-ui/icons/Language';
import AlbumIcon from '@material-ui/icons/Album';
import Avatar from '@material-ui/core/Avatar';
import HistoryIcon from '@material-ui/icons/History';
import { getUser } from '../../helpers';

const kCanEditRole = [false, true, true, true];
const menuDash = [
  {to: "/index.html", active: [""], name:"dashboard", src:"img/dashboad.png", class: "menu-icon-small", icon:ComputerIcon, line1:"ダッシュボート", line2:""}
];

const menuGeneral = [
  {to: "/index.html?p=terminal", active: ["terminal"], name:"terminals", src:"img/com.png", class: "menu-icon-small", icon:ComputerIcon, line1:"管理番号一覧", line2:""},
  {to: "/index.html?p=user", active: ["user"], name:"users", src:"img/user_menu.png", class: "menu-icon-small", icon:PersonIcon, line1:"ユーザー一覧", line2:""},
  {to: "/index.html?p=pcspec", active: ["pcspec"], name:"systems", src:"img/system.png", class: "menu-icon-small", icon:LanguageIcon, line1:"導入一覧", line2:""},
  {to: "/index.html?p=installed_info_search", active: ["installed_info_search"],src:"img/software.png", name:"installed_info_search", class: "menu-icon-small", icon:AlbumIcon,  line1:"ソフトウェア", line2:"インストール状態"},
  {to: "/index.html?p=history", active: ["history"], name:"history", src:"img/history.png", class: "menu-icon-small", icon:HistoryIcon, line1:"稼働履歴", line2:""},
  {to: "/index.html?p=history-status", active: ["history-status"], name:"historystatus", src:"img/GanttIcon.png", class: "menu-icon-small", icon:HistoryIcon, line1:"稼働状況確認", line2:""},
  {to: "/index.html?p=stamp", active: ["stamp"], name:"stamp", src:"img/GanttIcon.png", class: "menu-icon-small", icon:HistoryIcon, line1:"打刻", line2:""},
  {to: "/index.html?p=attend-status", active: ["attend-status"], name:"attend-status", src:"img/GanttIcon.png", class: "menu-icon-small", icon:HistoryIcon, line1:"勤怠状況確認", line2:""},
];

const menuMaster = [
  {to: "/index.html?p=terminal-edit", active: ["terminal-edit", "terminal-new"], name:"terminals-edit", src:"img/com.png", class: "menu-icon-small", icon:HistoryIcon, line1:"登録端末編集", line2:""},
];

const menuMaster0 = [
  {to: "/index.html?p=accounts", active: ["accounts", "account-new", "account-edit"], name:"users-edit", src:"img/account.png", class: "menu-icon-small", icon:HistoryIcon, line1:"アカウント情報編集", line2:""},
  {to: "/index.html?p=setting", active: ["setting"], name:"master-edit", src:"img/master.png", class: "menu-icon-small", icon:HistoryIcon, line1:"マスタ編集", line2:""},
];

const menuDownload = [
  {to: "/index.html?p=version", active: ["version"], name:"download", src:"img/soft.png", class: "menu-icon-small", icon:HistoryIcon, line1:"データ収集ソフト", line2:""},
];

class Menu extends Component {
  constructor(props) {
    super(props);
    this.state = {
      Hpa27Version: null,
      loading: false
    };
  }

  // getWindowsOS() {
  //   if(navigator.appVersion.indexOf("Windows NT 10.")!==-1){
  //     return 'Windows 10';
  //   } else if (navigator.appVersion.indexOf('Windows NT 6.4')!==-1) {
  //     return 'Windows 10';
  //   }else if(navigator.appVersion.indexOf("Windows NT 6.3")!==-1){
  //     return "Windows 8.1";
  //   }else if(navigator.appVersion.indexOf("Windows NT 6.2")!==-1){
  //     return "Windows 8";
  //   }else if(navigator.appVersion.indexOf("Windows NT 6.1")!==-1){
  //     return "Windows 7";
  //   }else if(navigator.appVersion.indexOf("Windows NT 6.0")!==-1){
  //     return "Windows Vista";
  //   }else if(navigator.appVersion.indexOf("Windows NT 5.2")!==-1){
  //     return "Windows XP";
  //   }else if(navigator.appVersion.indexOf("Windows NT 5.1")!==-1){
  //     return "Windows XP";
  //   }else{
  //     return '';
  //   }
  // };

  // componentDidMount() {
  //   let os = "";
  //   if(navigator.appVersion.indexOf("Windows ")!==-1){
  //       os = getWindowsOS();
  //   }else{
  //       os = navigator.platform;
  //   }
  //   let systemArchitecture = navigator.userAgent.indexOf('WOW64') !== -1 || navigator.userAgent.indexOf('Win64') !== -1 ? ' 64bit' : ' 32bit';
  //   // console.log(os + systemArchitecture);

  //   const data = {
  //     "process_type": "getHpa27VersionInfo",
  //     "os_info": os + systemArchitecture, // "Windows 11 64bit"
  //   };
  //   console.log(data);
  //   const requestOptions = {
  //       method: 'POST',
  //       headers: authHeader(),
  //       body: JSON.stringify(data),
  //   };

  //   this.setState({ loading: true });
  //   fetch(api.url, requestOptions)
  //       .then(response => response.json())
  //       .then(json => {
  //         // console.log(json.data);
  //         // const { versions } = this.props;
  //         // versions.Hpa27VersionOsInfo=json.data.version_info;
  //         dispatch(receiveVersionsOs(params, json))
  //         this.setState({ loading: false, Hpa27Version: json.data.version_info})
  //       })
  //       .catch((error) => {
  //         console.error('Error:', error);
  //       });
  // };
  
  render() {
    const user = getUser();
    const { path } = this.props;
    // console.log(this.props);
    return (
      <div className='menu-container'>
        <img className="menuIcon" src="img/img1.png" alt="Hakaru+ Cloud" />
        {/** ================== メニュー ================== */}
        <header>端末管理システム</header>
        <ul>
          {menuDash.map(menuItem => 
            <li key={menuItem.name}>
              <Link className='menu-master__item' to={menuItem.to}>
                <Avatar variant="square" src={menuItem.src} className={menuItem.class} />
                <MenuOption active={menuItem.active.indexOf(path) > -1 ? true : false} line1={menuItem.line1} line2={menuItem.line2}/>
              </Link>
            </li>
          )}
        </ul>

 　　　  {/** ================== 【端末】 ================== */}
        <div className="menu-master">【端末】</div>
        <ul>
        
          {menuGeneral.map(menuItem => 
            <li key={menuItem.name}>
              <Link className='menu-master__item' to={menuItem.to}>
                <Avatar variant="square" src={menuItem.src} className={menuItem.class} />
                <MenuOption active={menuItem.active.indexOf(path) > -1 ? true : false} line1={menuItem.line1} line2={menuItem.line2}/>
              </Link>
            </li>
          )}
          
        </ul>
        
        {/** ================== 【ダウンロード】 ================== */}
        <div className="menu-master">【ダウンロード】</div>
        <ul>
          
          {/* {
            this.state.loading === false &&
            (<li>
                <Link className='menu-master__item' to='/index.html?p=version'>
                  <MenuMaster active={path === 'version' ? true : false} Icon="●" line1={`データ収集ソフト`}/>
                </Link>
            </li>)
          } */}
          
           {menuDownload.map(menuItem => 
              <li key={menuItem.name}>
                <Link className='menu-master__item' to={menuItem.to}>
                  <Avatar variant="square" src={menuItem.src} className={menuItem.class} />
                  <MenuOption active={menuItem.active.indexOf(path) > -1 ? true : false} line1={menuItem.line1} line2={menuItem.line2}/>
                </Link>
              </li>
            )}
          
        </ul>

        {/** ================== 【設定・編集】 ================== */}
        {<div>
          <div className="menu-master">【設定・編集】</div>
          <ul>
            
            {kCanEditRole[user.role] && menuMaster.map(menuItem => 
              <li key={menuItem.name}>
                <Link className='menu-master__item' to={menuItem.to}>
                  <Avatar variant="square" src={menuItem.src} className={menuItem.class} />
                  <MenuOption active={menuItem.active.indexOf(path) > -1 ? true : false} line1={menuItem.line1} line2={menuItem.line2}/>
                </Link>
              </li>
            )}
            
            {menuMaster0.map(menuItem => 
              <li key={menuItem.name}>
                <Link className='menu-master__item' to={menuItem.to}>
                  <Avatar variant="square" src={menuItem.src} className={menuItem.class} />
                  <MenuOption active={menuItem.active.indexOf(path) > -1 ? true : false} line1={menuItem.line1} line2={menuItem.line2}/>
                </Link>
              </li>
            )}
            
          </ul>
        </div>}
        {/* <ul>
          <li><Link className='menu-item' to="/">アダプタ</Link></li>
          <li><Link className='menu-item' to="/installed_app">インストールアプリ</Link></li>
          <li><Link className='menu-item' to="/pcspec">PCスペック</Link></li>
          <li><Link className='menu-item' to="/running_app">動作中アプリ</Link></li>
          <li><Link className='menu-item' to="/setting">設定</Link></li>
          <li><Link className='menu-item' to="/user">ユーザー</Link></li>
          <li><Link className='menu-item' to="/version">バージョン</Link></li>
        </ul> */}

        {/** ================== ログアウト ================== */}
        <Link className='menu-logout' to="/index.html?p=login" onClick={()=>{this.props.logout()}}>ログアウト</Link>
      </div>
    )
  }
}

export default Menu
